module.exports = __webpack_public_path__ + "static/media/settings_remote-24px.a297c13a.svg";